import { List, ListItem, ListItemText } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv, WideBox } from '../../styles/styles';
import InviteExtUsers from '../InviteExtUsers';
import InviteForm from '../InviteForm';

const InviteUser = () => {
  const { authStore, orgStore } = useRootStore();
  const [selectedTab, setSelectedTab] = useState('invite-user');
  const { settings } = orgStore;

  const createInvite = async values => {
    const { email, roles, contactId, contact } = values;
    const { Name } = contact;
    const { name: inviterName, email: inviterEmail } = authStore;
    try {
      await authStore.request.post(
        `${process.env.REACT_APP_API}/api/invitation`,
        {
          email,
          roles,
          contactId,
          name: Name,
          orgName: settings.Name,
          emailTemplateData: {
            inviter_name: inviterName,
            inviter_email: inviterEmail,
          },
        },
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <FlexDiv>
      <WideBox style={{ maxWidth: '550px' }}>
        <div style={{ display: 'flex', height: '400px' }}>
          <List
            style={{
              borderRight: 'solid 0.5px rgb(224, 224, 224)',
              marginTop: '10px',
              width: '44%',
            }}
          >
            <ListItem
              button
              selected={selectedTab === 'invite-user'}
              onClick={() => setSelectedTab('invite-user')}
            >
              <ListItemText
                primary="Invite A User"
                secondary="Send an invite to join your organization"
              />
            </ListItem>
            <ListItem
              button
              selected={selectedTab === 'invite-ext-usrs'}
              onClick={() => setSelectedTab('invite-ext-usrs')}
            >
              <ListItemText
                primary="Invite Users From External System"
                secondary="Send invitations to users from your synced accounting system"
              />
            </ListItem>
          </List>
          <div
            style={{
              width: '55%',
              paddingLeft: '15px',
              boxSizing: 'border-box',
            }}
          >
            {selectedTab === 'invite-user' && (
              <InviteForm handleSubmission={createInvite} />
            )}
            {selectedTab === 'invite-ext-usrs' && <InviteExtUsers />}
          </div>
        </div>
      </WideBox>
    </FlexDiv>
  );
};

export default InviteUser;
